export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "cryptocasino-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "cryptocasino-themeWrapLive" */'./LiveThemeImporter'),
  },
};
